export default __webpack_public_path__ + "static/media/more.fdaaff61.svg";